$(document).ready(function () {

    // Mobile Menu Slide In

    $(function() {
        mobileMenuToggle();
        closeMobileMenu();
    });

    var toggler = $('.navbar-toggler');
    var menu = $('.mobile-nav-menu');
    var toggleAnimation = $('.animated-icon3');

    function mobileMenuToggle() {
        toggler.on('click', function (e) {
            menu.toggleClass('active');
            $('.main').toggleClass('mobile-nav-opened');
            toggleAnimation.toggleClass('open');
            return false;
        });
    }

    function closeMobileMenu() {
        $('html').click(function(e) {
            if (!menu.is(e.target) // The target of the click isn't the container.
                && menu.has(e.target).length === 0) // Nor a child element of the container
            {
                menu.removeClass('active');
                $('.main').removeClass('mobile-nav-opened');
                toggleAnimation.removeClass('open');
            }
        });
    }

    // Desktop Menu Slide Down

    var navLink = $('.nav-link[data-mega-toggle]');

    navLink.click(function () {
        $('div[data-menu-page].active').slideToggle(400).delay(200).toggleClass('active');
        var mega = $(this).data('mega-toggle');
        if (!mega) {
            $('.nav-link.active').toggleClass('active');
            $('div[data-menu-page].active').slideToggle(400).delay(200).toggleClass('active');
        }
        if ($(this).hasClass('active')) {
            $(this).toggleClass('active');
            return false;
        }
        $('div[data-menu-page].active').toggleClass('active');
        $('.nav-link.active').toggleClass('active');
        $('div[data-menu-page="' + mega + '"]').toggleClass('active').hide().slideToggle(400);
        $(this).toggleClass('active');
        return false;
    });

    navLink.click(function () {
        var mega = $(this).data('mega-toggle');
        if (!mega) {
            return true;
            $('.nav-link.active').toggleClass('active');
            $('div[data-menu-page].active').slideToggle(400).delay(200).toggleClass('active');
        }
        return false;
    });

    $('.slide-out-nav-menu').mouseleave(function () {
        window.setTimeout(function(){
            $('.nav-link.active').toggleClass('active');
            $('div[data-menu-page].active').slideToggle('slow').delay(200).toggleClass('active');
            }, 500);
    });
});


